<template>
  <div style="padding-left: 10px">
    <el-row class="search-box">
      <el-input v-model.trim="sn" placeholder="请扫SN码" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>
    <el-card shadow="never" class="info-card">
      <el-row>
        <el-col :span="3" class="item-text">SN：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.sn }}</el-col>
        <el-col :span="3" class="item-text">订单编号：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.order_no }}</el-col>
        <el-col :span="2" class="item-text">客户名称：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.customer }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="item-text">下单日期：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.order_date }}</el-col>
        <el-col :span="3" class="item-text">品类：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.catalog_name }}</el-col>
        <el-col :span="2" class="item-text">原产品：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.originProduct }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="item-text">当前工站：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.current_station }}</el-col>
        <el-col :span="3" class="item-text">当前工站状态：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.current_station_status }}</el-col>
        <el-col :span="2" class="item-text">目标产品：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.targetProduct }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="item-text">当前工站责任人：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.current_station_user_id }}</el-col>
        <el-col :span="3" class="item-text">下一站：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.next_station }}</el-col>
        <el-col :span="2" class="item-text">进流水线时间：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.in_line_time }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="item-text">出流水线时间：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.out_line_time }}</el-col>
        <el-col :span="3" class="item-text">是否全部结束：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.total_end }}<FrameButton :key="snInfo.id" :parentData="snInfo" :button="detailButton"></FrameButton></el-col>
        <el-col :span="2" class="item-text">发货时间：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.ship_date }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="3" class="item-text">发货单号：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.ship_no }}</el-col>
        <el-col :span="3" class="item-text">物流单号：</el-col>
        <el-col :span="5" class="item-value">{{ snInfo.logistics_no }}</el-col>
        <el-col :span="2" class="item-text">物流公司：</el-col>
        <el-col :span="6" class="item-value">{{ snInfo.logistics_company }}</el-col>
      </el-row>
    </el-card>
    <span>物料更换明细</span>
    <el-card shadow="never" >
    <frame-query ref="frameQuery" componentParam="rebuild_material_change_record" style="margin-top: -20px"
                 :parent-data="{item_id:this.snInfo.item_id}"></frame-query>
    </el-card>
  </div>

</template>

<script>
import {Refresh} from '@element-plus/icons-vue'
export default {
  name: "SnSearch",
  components: {Refresh},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      sn: '',
      loading: false,
      snInfo: {},
      detailButton:{
        "component": "button",
        "text":true,
        "label":"工站作业详情",
        "style":"margin-left:50px",
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameQuery", "type": "rebuild_sn_station_detail","title":"工站作业详情","width":800,"height":600}
      },
    }
  },
  computed: {
  },
  provide() {
    return {
      $fn: {
        reset: () => {
          this.sn = ''
          this.reset();
        }
      }
    }
  },
  methods: {
    async search() {
      this.reset()
      //this.$refs.frameForm.formInfo = {} //清空作业表单内容

      if (!this.sn) {
        return this.$refs.searchMessage.showError('SN码不能为空')
      }

      this.loading = true
      this.$http('rebuildItemService.getSnInfo', {
        sn: this.sn
      }, false).then(data => {
        this.loading = false
        this.snInfo = data.snInfo || {}
        //this.$refs.frameForm.initForm()
        //return this.$refs.searchMessage.showSuccess('状态正常，请作业');
        this.$refs.frameQuery.search();
      }, errMsg => {
        this.loading = false
        return this.$refs.searchMessage.showError(errMsg)
      })

    },
    reset() {
      this.snInfo = {}
      this.$refs.searchMessage.clear()

    }
  }
}
</script>

<style scoped>
.el-row {
  line-height: 32px;
}

.el-card__body{
  padding: 0 !important;
}

.info-card {
  margin-top: 2px;
  margin-bottom: 2px;
}

.remind-card{
  margin-top: 10px;
  width: 1000px;
}

.info-card .el-row {
  display: flex;
}
.input {
  height: 32px;
  width: 350px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

.item-text {
  text-align: right;
  color:grey;
}

.login-user {
  position: absolute;
  right: 10px;
}

.item-value.red-tip {
  color: red;
}

</style>